import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Checkbox from '@mui/material/Checkbox';
import Grid2 from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import { Team } from '../../models/Tournament';

export const TeamSelection = ({
  teams,
  selectedTeamId,
  teamName,
  numberOfPlayers,
  handleTeamClick,
}: {
  teams: Team[];
  selectedTeamId?: number;
  teamName: string;
  numberOfPlayers?: number;
  handleTeamClick: (team: Team) => void;
}) => {
  if (teams.length === 0) {
    return <Typography>Nie masz jeszcze utworzonych drużyn.</Typography>;
  }

  const disableCheckbox = !!teamName || (numberOfPlayers ?? 0) > 0;

  return (
    <Grid2 container spacing={2}>
      {teams.map((team) => (
        <Grid2 size={{ xs: 12, sm: 6, lg: 4, xl: 3 }} key={team.id}>
          <Card>
            <CardActionArea onClick={() => handleTeamClick(team)}>
              <CardContent sx={{ display: 'flex', alignItems: 'center', padding: 'unset' }}>
                <Checkbox checked={selectedTeamId === team.id} onClick={() => handleTeamClick(team)} disabled={disableCheckbox} />
                <Typography>{team.name}</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid2>
      ))}
    </Grid2>
  );
};
